// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac1ef70d","453":"67af8c50","732":"6ae6a6ee"}[chunkId] + ".chunk.js";
};